import _ from 'lodash'
import { Getter, GetterTree } from 'vuex'

import { Booking, ModuleState, RootState } from './types'

export const availableDates: Getter<ModuleState, RootState> = state => {
  return state.availableDates
}

export const bookings: Getter<ModuleState, RootState> = state => {
  return state.bookings
}

export const findBy: Getter<ModuleState, RootState> = state => {
  return (predicate: any) => _.find(state.bookings, predicate)
}

export const filterBy: Getter<ModuleState, RootState> = state => {
  return (predicate: any) => _.filter(state.bookings, predicate)
}

export const asInterviewer: Getter<ModuleState, RootState> = (
  state,
  _getters,
  _rootState,
  rootGetters
) => {
  return state.bookings.filter(e => e!.offer!.interviewerId === rootGetters.currentUserId)
}

export const asInterviewee: Getter<ModuleState, RootState> = (
  state,
  _getters,
  _rootState,
  rootGetters
) => {
  return state.bookings.filter(e => e!.intervieweeId === rootGetters.currentUserId)
}

export const getters: GetterTree<ModuleState, RootState> = {
  asInterviewee,
  asInterviewer,
  availableDates,
  bookings,
  filterBy,
  findBy,
}

export default getters
